import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_upload_file_table = _resolveComponent("upload-file-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.IsShwoBtn && _ctx.typebtn !== 'text')
      ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible = true)),
          type: _ctx.typebtn
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.btnName), 1)
          ]),
          _: 1
        }, 8, ["type"]))
      : _createCommentVNode("", true),
    (_ctx.IsShwoBtn && _ctx.typebtn == 'text')
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: "javascript:void(0);",
          type: "link",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = true)),
          class: "theme-color",
          style: {"color":"#2f7bff"}
        }, _toDisplayString(_ctx.btnName), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      centered: true,
      keyboard: false,
      "mask-closable": false,
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
      width: 750,
      title: _ctx.btnName,
      "ok-text": "确认",
      "cancel-text": "取消",
      onOk: _ctx.uploadFilesFn
    }, {
      default: _withCtx(() => [
        _createVNode(_component_upload_file_table, {
          ref: "attachRef",
          value: _ctx.attachList,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.attachList) = $event)),
          "allow-edit": true,
          "biz-type": _ctx.bizType
        }, null, 8, ["value", "biz-type"])
      ]),
      _: 1
    }, 8, ["visible", "title", "onOk"])
  ], 64))
}